import React from 'react';
import merge from 'lodash/merge';
import { connect } from 'react-redux';
import { isEditingUIElementByName } from 'selectors/pathBuilder';
import * as actions from 'actions/pathBuilder/relatedUrls';
import { toggleEditingUIElementByName } from 'actions/pathBuilder';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import ContentMapping from 'components/shared/ContentMapping';
import Section, { SectionHeader } from '../Section';

function ContentMappingBase({ contentMappingProps, ...props }) {
  const ContentMappingConnected = ({ relatedUrls, ...connectedProps }) => (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          <span className="mr-4">{props.header}</span>
          <InfoTooltip tooltip={props.headerTooltip} />
        </span>
        {!connectedProps.editing && (
          <button
            type="button"
            className="u-linkBtn fz-base fw-n"
            onClick={connectedProps.toggleEditing}
          >
            <Icon name="edit" className="mr-4" />
            Edit
          </button>
        )}
      </SectionHeader>
      <ContentMapping
        {...merge(
          {
            mappings: relatedUrls,
            renderMapping: mapping => mapping.url,
            suggestionsProps: {
              filterKey: 'relatedUrl.id',
            },
          },
          connectedProps,
          contentMappingProps,
        )}
      />
    </Section>
  );

  const mapStateToProps = ({ pathBuilder, meta }) => ({
    editing: isEditingUIElementByName(pathBuilder, props.UIStateKey),
    relatedUrls: props.mappingsSelector(pathBuilder),
    viewAllRelatedUrls: meta.permissions.viewAllRelatedUrls,
  });

  const mapDispatchToProps = {
    toggleEditing: toggleEditingUIElementByName.bind(null, props.UIStateKey),
    onCreateMapping: actions.createRelatedUrlMapping,
    onRemoveMapping: actions.removeRelatedUrlMapping,
  };

  ContentMappingConnected.displayName = `ContentMappingBase(${props.displayName})`;

  return connect(mapStateToProps, mapDispatchToProps)(ContentMappingConnected);
}

export default ContentMappingBase;
